import { useEffect, useState } from "react";
import { FileText, Download } from "lucide-react";
import api from "../../lib/apiClient";
import { ProHeader, StatusBadge, money, fmtDate, Loading, Empty } from "./proUi";
import { downloadInvoice } from "./invoice";

// Factures : commandes du pro dont une facture est disponible (après paiement).
export default function ProFactures() {
  const [orders, setOrders] = useState(null);
  useEffect(() => {
    api.get("/marketplace/orders")
      .then((r) => setOrders((r.data.orders || []).filter((o) => o.role === "pro" && !["PENDING_PAYMENT", "CANCELLED"].includes(o.status))))
      .catch(() => setOrders([]));
  }, []);
  if (orders === null) return <Loading />;
  return (
    <div className="space-y-6" data-testid="pro-factures-page">
      <ProHeader eyebrow="Mon activité" title="Mes factures"
        subtitle="Télécharge les justificatifs de tes prestations payées (format CEHN-AAAA-NNNNN)." />
      {orders.length === 0 ? (
        <Empty icon={FileText} title="Aucune facture disponible" hint="Une facture est générée dès qu'une commande est payée." testid="pro-factures-empty" />
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="flex items-center justify-between gap-3 bg-[#18181E] border border-zinc-800 rounded-2xl p-5" data-testid={`facture-${o.id}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <FileText className="w-4 h-4 text-amber-400 shrink-0" />
                  <h3 className="font-display font-bold text-zinc-100 truncate">{o.invoice_number || "Facture à générer"}</h3>
                  <StatusBadge status={o.status} />
                </div>
                <p className="text-xs text-zinc-500 mt-1">{o.title || o.request_title} · {o.client_name} · {fmtDate(o.paid_at || o.created_at)}</p>
              </div>
              <div className="text-right shrink-0">
                <div className="font-display font-extrabold text-amber-400">{money(o.amount, o.currency)}</div>
                <button onClick={() => downloadInvoice(o.id, o.invoice_number)} data-testid={`facture-download-${o.id}`} className="mt-1 inline-flex items-center gap-1.5 text-sm text-zinc-300 hover:text-amber-400"><Download className="w-4 h-4" />Télécharger</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
